import { Component, inject, OnInit } from '@angular/core';
import { Customer, SelectedCustomerService } from 'gung-standard';
import { SummarizeOrderJeevesComponent } from 'gung-standard-jeeves';
import { first } from 'rxjs';

@Component({
    selector: 'tylo-summarize-order-jeeves',
    templateUrl: './tylo-summarize-order-jeeves.component.html',
    styleUrls: ['./tylo-summarize-order-jeeves.component.css'],
    standalone: false
})
export class TyloSummarizeOrderJeevesComponent extends SummarizeOrderJeevesComponent implements OnInit {
  private selectedCustomerService = inject(SelectedCustomerService);
  isUser: boolean;
  shouldShowAddressInput: boolean = true;

  ngOnInit() {
    super.ngOnInit();
    this.authService.getRoles().subscribe(roles => {
      this.isUser = roles.length === 1 && roles.includes('USER');
    });
    this.selectedCustomerService
      .getSelectedCustomer()
      .pipe(first())
      .subscribe(customer => {
        this.shouldShowAddressField(customer);
    });
  }

  protected nextBtnClickedCb(nextInfo?: any) {
    if (this.checkout.extra._gungEditedAddressFields) {
      const standardAddressData: { [s: string]: string } = {};

      if (this.customer.extra?.fr?.ftgpostadr5) {
        standardAddressData.ordlevadr1 = this.customer.extra.fr.ftgnamn;
        standardAddressData.ordlevadr2 = this.customer.extra.fr.ordlevadr5;
        standardAddressData.ordlevadr3 = this.customer.extra.fr.ftgpostadr5;
        standardAddressData.ordlevadr4 = this.customer.extra.fr.ftgpostlevadr3;
        standardAddressData.ordlevadrlandskod = this.customer.extra.fr.landskod;
        standardAddressData.ordlevadrprovincecode = this.customer.extra.fr.provincecode;
      } else {
        standardAddressData.procargs = this.checkout.extra.procargs || {};
        standardAddressData.ordlevadr1 = this.customer.extra.fr.ftgnamn;
        standardAddressData.ordlevadr2 = this.customer.extra.fr.ftgpostadr1;
        standardAddressData.ordlevadr3 = this.customer.extra.fr.ftgpostadr2;
        standardAddressData.ordlevadrlandskod = this.customer.extra.fr.landskod;
      }

      standardAddressData.ordlevadr4 = (this.customer.extra.fr.ftgpostlevadr3 || this.customer.extra.fr.ftgpostadr3 || '').trim();
      standardAddressData.ftgpostnr = (this.customer.extra.fr.ftgpostnr || '').trim();

      const currentAddressData: { [s: string]: string } = {
        /*ordlevadr1: this.checkout?.extra?.procargs?.ordlevadr1,
        ordlevadr2: this.checkout?.extra?.procargs?.ordlevadr2,
        ordlevadr3: this.checkout?.extra?.procargs?.ordlevadr3,
        ordlevadr4: this.checkout?.extra?.procargs?.ordlevadr4,
        ftgpostnr: this.checkout?.extra?.procargs?.ftgpostnr,
        ordlevadrlandskod: this.checkout?.extra?.procargs?.ordlevadrlandskod,
        ordlevadrprovincecode: this.checkout?.extra?.procargs?.ordlevadrprovincecode*/
      };

      for (const key in currentAddressData) {
        const currentValue = currentAddressData[key] ?? '';
        const standardValue = standardAddressData[key] ?? '';
        if (currentValue === standardValue) {
          if (this.checkout?.extra?.procargs?.[key]) {
            delete this.checkout?.extra?.procargs?.[key];
          }
        }

        if (this.checkout?.extra?.procargs?.[key] == null || this.checkout?.extra?.procargs?.[key] == undefined) {
          delete this.checkout.extra.procargs[key];
        }
      }

    } else {
      const fields: string[] = ['ordlevadr1', 'ordlevadr2', 'ordlevadr3', 'ordlevadr4', 'ftgpostnr', 'ordlevadrlandskod', 'ordlevadrprovincecode'];
      for (const key in this.checkout.extra.procargs) {
        if (this.checkout.extra.procargs.hasOwnProperty(key) && fields.includes(key)) {
          delete this.checkout.extra.procargs[key];
        }
      }
    }

    if (!this.shouldShowAddressInput) {
      delete this.checkout.extra?.procargs?.ordlevadr2;
    }

    this.stepDone.emit(this.checkout);
  }

  /**
     * If customer's momskod is 1, then don't show the regular Address field (different field from delivery address)
     * Per request from support: https://support.gung.se/a/tickets/622903
     */
    protected shouldShowAddressField(selectedCustomer: Customer) : void {
      const customerMomsKod = selectedCustomer?.extra?.kus?.momskod;
      this.shouldShowAddressInput = customerMomsKod !== 1;
    }
}
